import { Box, CircularProgress } from "@mui/material";

const LoadingCircle = () => {
  return (
    <Box display="flex">
      <Box m="auto">
        <CircularProgress color="secondary" />
      </Box>
    </Box>
  );
};

export default LoadingCircle;
